/* eslint-disable no-restricted-syntax */
import { getInterval } from "../DatePresets";
/**
 * Get filters from local storage for the front menus
 */
export function getLocalStorageFrontValues(assistantID, page, attribute, filters) {
	// Get filters for assistant
	let actualFilters = filters[assistantID];
	if (!actualFilters) return null;
	// Get filters for assistant > page
	actualFilters = actualFilters[page];
	if (!actualFilters) return null;
	// Get filters for assistant > page > attribute
	let actualFilter = actualFilters[attribute];
	if (!actualFilter) return null;
	// Return front value

	switch (actualFilter.type) {
		case "datetime": {
			// Mode auto = recompute interval
			if (actualFilter.mode === "auto" && actualFilter.code) {
				let interval = getInterval(actualFilter.code);
				return interval;
			} else {
				return actualFilter.values;
			}
		}
		default:
			return actualFilter.front;
	}
}
/**
 * Get filters from local storage for the back requests
 */
export function getLocalStorageBackValues(assistantID, page, filters) {
	// Get filters for assistant
	let actualFilters = filters[assistantID];
	if (!actualFilters) return {};
	// Get filters for assistant > page
	actualFilters = actualFilters[page];
	if (!actualFilters) return {};
	// Map filters
	let keys = Object.keys(actualFilters);
	let backFilters = {};
	for (let key of keys) {
		switch (actualFilters[key].type) {
			case "datetime": {
				let filter = actualFilters[key];
				// Mode auto = recompute interval
				if (filter.mode === "auto" && filter.code) {
					let interval = getInterval(filter.code);
					backFilters[key] = { name: filter.attribute, type: filter.type, value: interval };
				} else {
					backFilters[key] = { name: filter.attribute, type: filter.type, value: filter.values };
				}
				break;
			}
			default:
				backFilters[key] = actualFilters[key].back;
				break;
		}
	}
	return backFilters;
}
